import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fill-height":""}},[_c(VRow,{attrs:{"align-content":"center","justify":"center"}},[_c(VCol,{attrs:{"lg":"6"}},[_c('h3',[_vm._v("Kia ora")]),_c('p',[_vm._v(" Thanks for your interest in ordering products from Cerno. ")]),_c('p',{staticClass:"subtitle-1"},[_vm._v(" If you have not been provided with a link to do so, please contact your organisation's HR team. ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }